module.exports = __webpack_public_path__ + "static/img/icon2.404cad6c.svg";